<div class="manage-payment-form-container">
  <div class="bolt-container">
    <bolt-progress-bar appFocusOnInit arialabel="setup automatic payments progress value is 100%" class="progress-bar-container to-container" value="100"></bolt-progress-bar>
    <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Payment plan: confirmation</h1>

    <div class="bolt-row">
      <div class="bolt-col-sm-12">
        @if (isPayplanUpdateSuccess()) {
          <bolt-notification class="bolt-space-bottom-2xl to-container" type="success">
            Nice work! You are now on {{ payPlan }}. Your budget will thank you for eliminating all those monthly installment fees.
          </bolt-notification>
          <section>
            <app-payment-sub-header>Confirmation details</app-payment-sub-header>
            <app-confirmation-details-table [rows]="confirmationDetails"></app-confirmation-details-table>
          </section>

        } @else {
          <bolt-notification class="bolt-space-bottom-2xl to-container" type="error" id="error-notification">
            We are unable to process your request. For assistance, please
            <a [href]="contactusUrl" target="_blank" rel="noopener">contact us.</a>
          </bolt-notification>
        }
      </div>

      <div class="bolt-col-sm-12">
        @if (isPayplanUpdateSuccess()) {
          <app-payment-sub-header>Upcoming payments</app-payment-sub-header>
          <div class="bolt-space-bottom-2xl">
            <div class="bolt-row">
              <div class="bolt-col">
                <strong>{{ billLabel }}</strong>
              </div>
              <div class="bolt-col">
                <strong>{{ amountLabel }}</strong>
              </div>
              <div class="bolt-col">
                <strong>{{ dateLabel }}</strong>
              </div>
            </div>
            @for (bill of upComingPaymentModel?.recordInfo; track bill) {
              <div class="bolt-row">
                <div class="bolt-col">
                  {{ bill.billType }}
                </div>
                <div class="bolt-col">
                  {{ bill.amount }}
                </div>
                <div class="bolt-col">
                  {{ bill.dateValue | date: 'MM/dd/yyyy' }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  @if (canPayNow) {
    <bolt-button-bar>
      <is-button slot="cancel" id="print-button" (click)="showPrintDialog()">Print</is-button>
      <is-button slot="back" id="secondary-button" (click)="cancelEditPaymentPlan()">Payment preferences</is-button>
      <is-button slot="forward" (click)="navigateToMakeAPayment()" id="submit-button" [type]="solid">Make a payment</is-button>
    </bolt-button-bar>
  } @else {
    <bolt-button-bar>
      <is-button slot="cancel" id="print-button" (click)="showPrintDialog()">Print</is-button>
      <is-button slot="back" id="secondary-button" (click)="cancelEditPaymentPlan()">Payment preferences</is-button>
    </bolt-button-bar>
  }
</div>
